import { render } from "./Riba.vue?vue&type=template&id=644468d1"
const script = {}
script.render = render

export default script